import { render, staticRenderFns } from "./PDI.vue?vue&type=template&id=83a0770c&scoped=true"
import script from "./PDI.vue?vue&type=script&lang=js"
export * from "./PDI.vue?vue&type=script&lang=js"
import style0 from "./PDI.vue?vue&type=style&index=0&id=83a0770c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a0770c",
  null
  
)

export default component.exports